module.exports = __webpack_public_path__ + "static/Testimonial2-ab2fcad6fbe7795f98e32c062ca9dd38.jpg";